import {LinkExternalIcon, PlusCircleIcon, type Icon} from '@primer/octicons-react'
import {ActionList} from '@primer/react'

export type AIResourceTypeFilter = {
  label: string
  href: string
  icon: Icon
}

export type ResourceTypeFilterProps = {
  resourceTypes: readonly AIResourceTypeFilter[]
  labelFilterHref: string
  advancedSearchHref: string
}

export function ResourceTypeFilter({resourceTypes, labelFilterHref, advancedSearchHref}: ResourceTypeFilterProps) {
  return (
    <ActionList aria-label="AI resource filters">
      <ActionList.Divider />
      <ActionList.Group>
        <ActionList.GroupHeading as="h2">Resource types</ActionList.GroupHeading>
        {resourceTypes.map(resourceType => (
          <ActionList.LinkItem key={`${resourceType.label}-${resourceType.href}`} href={resourceType.href}>
            <ActionList.LeadingVisual>
              <resourceType.icon />
            </ActionList.LeadingVisual>
            {resourceType.label}
          </ActionList.LinkItem>
        ))}
      </ActionList.Group>

      <ActionList.Divider />
      <ActionList.Group>
        <ActionList.GroupHeading as="h2">Advanced</ActionList.GroupHeading>
        <ActionList.LinkItem href={labelFilterHref}>
          <ActionList.LeadingVisual>
            <PlusCircleIcon />
          </ActionList.LeadingVisual>
          Label
        </ActionList.LinkItem>
      </ActionList.Group>

      <ActionList.Divider />
      <ActionList.LinkItem href={advancedSearchHref} className="fgColor-accent">
        <ActionList.LeadingVisual className="fgColor-accent">
          <LinkExternalIcon />
        </ActionList.LeadingVisual>
        Advanced search
      </ActionList.LinkItem>
    </ActionList>
  )
}
